const formatDate = (timestamp) => {
  if (!timestamp) return "";
  
  // Removed * 1000 because your timestamp is already in milliseconds
  const date = new Date(timestamp); 
  
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

export {
  formatDate
};